const Spacer = ({ data }) => {
  const {
    backgroundColor = "",
    desktopHeight = "",
    ipadHeight = "",
    mobileHeight = "",
  } = data

  const toCssUnit = value =>
    typeof value === "number" ? `${value}px` : value || undefined

  const style = {
    backgroundColor,
    color: backgroundColor,
    "--spacer-desktop-height": toCssUnit(desktopHeight),
    "--spacer-ipad-height": toCssUnit(ipadHeight),
    "--spacer-mobile-height": toCssUnit(mobileHeight),
  }

  return (
    <div className="cmp-separator" aria-hidden="true">
      <hr className="cmp-separator__horizontal-rule" style={style} />
    </div>
  )
}

export default Spacer
